// extracted by mini-css-extract-plugin
export default {"header":"VLiyUs","title":"zBL3Ek","list":"EaYLj6","mobile":"YOOIcZ"};